import { render, staticRenderFns } from "./productionTest.vue?vue&type=template&id=730ffbb0&scoped=true"
import script from "./productionTest.vue?vue&type=script&lang=js"
export * from "./productionTest.vue?vue&type=script&lang=js"
import style0 from "./productionTest.vue?vue&type=style&index=0&id=730ffbb0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730ffbb0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('730ffbb0')) {
      api.createRecord('730ffbb0', component.options)
    } else {
      api.reload('730ffbb0', component.options)
    }
    module.hot.accept("./productionTest.vue?vue&type=template&id=730ffbb0&scoped=true", function () {
      api.rerender('730ffbb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/product-details/productionTest.vue"
export default component.exports